import { Card, Collapse } from 'react-bootstrap'
import style from '../Styles/index.module.scss'
import { IProduct, IProductGroup } from '../../../types/product'
import ProductCard from '../../ProductCard/ProductCard'
import { NoData } from '../../NoData'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import AppButton from '../../buttons/AppButton/AppButton'
import { ModalTypes } from '../../../types/modals'
import { showModal } from '../../../store/actions/modalActions'
import { User } from '../../../entity/User'
import { useExpand } from '../../../hooks/useExpand'
import {
    Draggable,
    DraggableProvided,
    Droppable,
    DroppableProvided,
} from 'react-beautiful-dnd'
import { getGroupProducts } from '../utils'

interface IProductsGroupsProps {
    productsList: IProduct[]
    groupData: IProductGroup
    hideInactive: boolean
    index?: any
}

export const ProductsGroups = (props: IProductsGroupsProps) => {
    const dispatch = useAppDispatch()
    const authUser = new User()
    const { productsList, groupData, hideInactive, index } = props

    const products = getGroupProducts(productsList, groupData)

    const { group_id: groupId } = groupData
    const expandBtnClassName = 'ms-3 btn-clean border-none'
    const { expandBtn, expanded, toggle } = useExpand({
        isExpanded: true,
        uniqueID: groupId,
        ariaID: groupId,
        className: expandBtnClassName,
    })

    const deleteGroupHandle = (): void => {
        dispatch(
            showModal(ModalTypes.DELETE_PRODUCTS_GROUP_MODAL, {
                groupId,
                products: products.map((product: IProduct) => product.guid),
            })
        )
    }

    return (
        <Draggable
            key={String(groupData.group_id)}
            draggableId={String(groupData.group_id)}
            index={index}
            isDragDisabled={!authUser.isAdministratorOrOwner()}
        >
            {(provided: DraggableProvided) => (
                <div
                    {...provided.draggableProps}
                    ref={provided.innerRef}
                >
                    <Card className={style.groupCard}>
                        <div
                            {...provided.dragHandleProps}
                            className={
                                expanded ? style.header : style.headerCollapsed
                            }
                        >
                            <div
                                className="w-100 d-flex align-items-center"
                                onClick={toggle}
                                aria-controls="collapse-card"
                                aria-expanded={expanded}
                            >
                                <h4 className={style.title}>
                                    {groupData?.name}
                                </h4>
                                {expandBtn}
                            </div>
                            {authUser.isAdministratorOrOwner() && (
                                <AppButton
                                    className="app-color-group"
                                    onClick={deleteGroupHandle}
                                    variant={'delete'}
                                />
                            )}
                        </div>

                        <Droppable
                            droppableId={String(groupData.group_id)}
                            direction="horizontal"
                            type="product"
                        >
                            {(provided: DroppableProvided, snapshot) => (
                                <div
                                    className={style.flexContainer}
                                    style={{
                                        backgroundColor: snapshot.isDraggingOver
                                            ? '#8dabc4'
                                            : '',
                                    }}
                                >
                                    <Collapse in={expanded}>
                                        <div
                                            id="collapse-card"
                                            style={{ width: '100%' }}
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {!products.length ? (
                                                <NoData
                                                    style={{ height: '300px' }}
                                                    messageId={
                                                        hideInactive
                                                            ? 'summary.noActiveProductsInGroup'
                                                            : 'summary.noProductsInGroup'
                                                    }
                                                />
                                            ) : (
                                                <div className={style.body}>
                                                    {products.map(
                                                        (
                                                            product: IProduct,
                                                            index: number
                                                        ) => (
                                                            <ProductCard
                                                                product={
                                                                    product
                                                                }
                                                                groupId={
                                                                    groupId
                                                                }
                                                                key={
                                                                    product.guid
                                                                }
                                                                index={index}
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Collapse>
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Card>
                </div>
            )}
        </Draggable>
    )
}
